import React from "react"
import { LEGAL_CONST } from "../constants"
import { Header, Item } from "../Components/Navigation"

export default ({
  module,
  history,
  name,
}: {
  module: string
  history: object
  name: string
}) => (
  <>
    <span>
      {Header(
        `/${LEGAL_CONST}/${module
          .split(" ")
          .map((el) => el[0].toUpperCase() + el.slice(1))
          .join(" ")}`
      )}
    </span>
    {Item({
      path: `/${LEGAL_CONST}/${module.toUpperCase()}/terms-and-conditions`,
      history,
      name,
    })}
  </>
)
